import findById from 'helpers/findById'
import replaceCamera from 'helpers/cameras/replaceCamera'
import capitalizeFirstLetter from 'helpers/capitalizeFirstLetter'
import calculatorUpdateHelpers from 'helpers/calculatorUpdateHelpers'

export default function batchUpdateCamera(state, action) {
  const camera = findById({ id: action.id, state: state.cameras })
  const { values, keys } = action

  if (!camera) return state

  const updatedCamera = keys.reduce(function(cam, key) {
    return calculatorUpdateHelpers()[`update${capitalizeFirstLetter(key)}`](cam, values[key])
  }, camera)

  return replaceCamera({ id: camera.id, updatedCamera, state })
}



// WEBPACK FOOTER //
// ./src/reducers/batchUpdateCamera.js